// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_TransactionHistoryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /contas/transaction_history/{id}
 *
 * Returns a list of transactions (contas_recebimentos rows) for the given
 * conta_id. Backed by Contas_recebimentos_model::lista_recebimentos_por_conta().
 */
import type { Contas_TransactionRow } from './Contas_TransactionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Contas_TransactionHistoryResponseDados = Contas_TransactionRow[];

export type Contas_TransactionHistoryResponse = ApiResponse<Contas_TransactionHistoryResponseDados>;

registerResponseContract('Contas_TransactionHistoryResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      recebimento_id:                   { type: 'number',  required: true },
      recebimento_data_cadastro:        { type: 'string',  required: false },
      recebimento_data_disponivel:      { type: 'string',  required: false },
      recebimento_franquia_id:          { type: 'number',  required: false },
      recebimento_franquia_nome:        { type: 'string',  required: false },
      recebimento_conta_id:             { type: 'number',  required: false },
      recebimento_conta_nome:           { type: 'string',  required: false },
      recebimento_forma_pagamento_id:   { type: 'number',  required: false },
      recebimento_forma_pagamento_nome: { type: 'string',  required: false },
      recebimento_origem:               { type: 'string',  required: false },
      recebimento_origem_id:            { type: 'number',  required: false },
      recebimento_registrado_por:       { type: 'string',  required: false },
      recebimento_registrado_por_id:    { type: 'string',  required: false },
      recebimento_valor:                { type: 'number',  required: false },
      recebimento_valor_liquido:        { type: 'number',  required: false },
      recebimento_valor_taxas:          { type: 'number',  required: false },
      recebimento_provedor:             { type: 'string',  required: false },
      recebimento_id_externo:           { type: 'string',  required: false },
      recebimento_observacoes:          { type: 'string',  required: false },
    },
  },
})
